//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MetasCrescimento from './MetasCrescimento';
import DetalhesConfMeta from './DetalhesConfMeta';

export default {
  name: 'PendenciaApuracao',
  components: {
    DetalhesConfMeta,
    MetasCrescimento,
  },
  props: {
    pendencia: null,
  },
  data() {
    return {
      evidencias: [
        {
          label: this.$t('label.sim'),
          value: true,
        },
        {
          label: this.$t('label.nao'),
          value: false,
        },
      ],
    };
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/PendenciaApuracao.vue?vue&type=script&lang=js&